module.exports = __webpack_public_path__ + "static/media/app-screen-1.fb589d5c.png";